import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CardComponent } from './controllers/card/card.component';
import { PickComponent } from './controllers/card/pick/pick.component';
import { AppComponent } from './app.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { RedirectComponent } from './controllers/redirect/redirect.component';
import { ErrorComponent } from './controllers/error/error.component';

export const mainRoutes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            {
                path: '',
                component: AppComponent
            },
            {
                path: 'card',
                children: [
                    {
                        path: '',
                        component: CardComponent,
                    },
                    {
                        path: 'pick',
                        component: PickComponent
                    }
                ]
            },
            {
                path: 'redirect',
                component: RedirectComponent
            },
            {
                path: 'error',
                component: ErrorComponent
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(mainRoutes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
